<template>
	<div>
		<Header :sel="5" @changePhone="changePhone" />
		<div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">
			<!-- your content here -->
			<div class="banner">

			</div>
			<!--banner-->

			<!--neirong-->
			<div class="bread_bg">
				<div class="bread"> <a href="javascript:void(0)" @click="go('/')">首页</a> - <a href="javascript:void(0)">关于我们</a></div>
			</div>
			<div class="neirong">
				<div class="news_c" v-html="detail.content"></div>
			</div>
			<Footer></Footer>

		</div>

	</div>
</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import { getNewDetail } from '@/api/reqFetch.js'
export default {
	name: '',
	layout: '',
	components: {
		Footer,
		Header
	},
	data() {
		return {
			detail: {},
			showPhone: false
		}
	},

	mounted() {
		this.getData()
	},


	methods: {
		go(url) {
			this.$router.replace(url)
		},
		changePhone(val) {
			this.showPhone = val
		},

		getData() {
			getNewDetail({ id: '1955868612092628992' }).then(res => {
				this.detail = res.data;
			});
		},



	}
}
</script>

<style scoped>
.banner {
	background-image: url('../../assets/images/banner_09.png');
}
</style>
